/**
 * Traduction des scopes OAuth Google en libellés lisibles.
 * Doit rester aligné avec la constante SCOPES de backend/src/services/auth.ts.
 */

export const BUSINESS_MANAGE_SCOPE = 'https://www.googleapis.com/auth/business.manage'

interface ScopeInfo {
  label: string
  description: string
}

const SCOPE_LABELS: Record<string, ScopeInfo> = {
  openid: {
    label: 'Identifiant de connexion',
    description: 'Authentification du compte Google.',
  },
  'https://www.googleapis.com/auth/userinfo.email': {
    label: 'Adresse e-mail',
    description: 'Lecture de l’adresse e-mail du compte Google.',
  },
  'https://www.googleapis.com/auth/userinfo.profile': {
    label: 'Profil Google',
    description: 'Lecture du nom et de la photo de profil.',
  },
  [BUSINESS_MANAGE_SCOPE]: {
    label: 'Fiches Google Business Profile',
    description: 'Synchronisation des avis, publications et statistiques des fiches.',
  },
  'https://www.googleapis.com/auth/analytics.readonly': {
    label: 'Google Analytics',
    description: 'Lecture seule des données d’audience et de trafic.',
  },
  'https://www.googleapis.com/auth/webmasters.readonly': {
    label: 'Google Search Console',
    description: 'Lecture seule des performances de recherche.',
  },
}

export interface DisplayScope {
  scope: string
  label: string
  description: string
}

/** Libellé lisible d’un scope. Jamais d’URL brute en sortie. */
export function describeScope(scope: string): DisplayScope {
  const known = SCOPE_LABELS[scope]
  if (known) return { scope, ...known }

  // Scope inconnu : on affiche l’identifiant court, pas l’URL complète.
  const shortName = scope.split('/').pop() || scope
  return {
    scope,
    label: `Autorisation « ${shortName} »`,
    description: 'Autorisation Google supplémentaire.',
  }
}

/** Liste ordonnée et dédoublonnée des autorisations à afficher. */
export function describeScopes(scopes: string[]): DisplayScope[] {
  const seen = new Set<string>()
  return scopes
    .filter((s) => {
      if (seen.has(s)) return false
      seen.add(s)
      return true
    })
    .map(describeScope)
}
